import React from "react";
import Jokes from "./components/Jokes";
import "./App.css"

const App = () => {
  return (
    <div className="App">
		<Jokes/>
    </div>
  );
};

export default App;
